const Exports = [
  {
    label: "Šprint 1. Broken Spell",
    semester: "(ZS)",
    data: "./documents/Exports/Sprint_1_Export.pdf",
    date: "22.10.2021",
    
    
  },
  {
    label: "Šprint 2. Code Busters",
    semester: "(ZS)",
    data: "./documents/Exports/Sprint_2_Export.pdf",
    date: "01.11.2021",
    
    
  },
  {
    label: "Šprint 3. Rock Solid",
    semester: "(ZS)",
    data: "./documents/Exports/Sprint_3_Export.pdf",
    date: "15.11.2021",
    
    
  },
  {
    label: "Šprint 4. Whispering Voices",
    semester: "(ZS)",
    data: "./documents/Exports/Sprint_4_Export.pdf",
    date: "29.11.2021",
  },
  {
    label: "Šprint 5. Legendary Catastros",
    semester: "(ZS)",
    data: "./documents/Exports/Sprint_5_Export.pdf",
    date: "13.12.2021",
  },
  {
    label: "Šprint 6. Fire Heart",
    semester: "(LS)",
    data: "./documents/Exports/Sprint_6_Export.pdf",
    date: "28.02.2022",
  },
  {
    label: "Šprint 7. Stranger Within",
    semester: "(LS)",
    data: "./documents/Exports/Sprint_7_Export.pdf",
    date: "14.03.2022",
  },
  {
    label: "Šprint 8. Petrified Xander",
    semester: "(LS)",
    data: "./documents/Exports/Sprint_8_Export.pdf",
    date: "28.03.2022",
  },
  {
    label: "Šprint 9. The Gatekeeper",
    semester: "(LS)",
    data: "./documents/Exports/Sprint_9_Export.pdf",
    date: "11.04.2022",
  },
  {
    label: "Šprint 10. Scaredy Cat",
    semester: "(LS)",
    data: "./documents/Exports/Sprint_10_Export.pdf",
    date: "25.04.2022",
  },
  {
    label: "Šprint 11. Dark Wish",
    semester: "(LS)",
    data: "./documents/Exports/Sprint_11_Export.pdf",
    date: "09.05.2022",
  },
]

export default Exports;
